import React from "react";
import { string, oneOfType, objectOf, number } from "prop-types";

const Plus = ({ style, className }) => (
	<i
		style={{
			...style,
			display: "inline-block",
			fill: "currentColor",
		}}
		className={className}>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			style={{
				width: "100%",
				height: "100%",
			}}
			viewBox="0 0 27 27">
			<g transform="translate(-319.466 -1185.466)">
				<line
					y2="11.932"
					transform="translate(332.966 1193.5)"
					fill="none"
					style={{ stroke: "currentcolor" }}
					strokeLinecap="round"
					strokeWidth="2"
				/>
				<line
					y2="11.932"
					transform="translate(338.932 1199.466) rotate(90)"
					fill="none"
					style={{ stroke: "currentcolor" }}
					strokeLinecap="round"
					strokeWidth="2"
				/>
			</g>
		</svg>
	</i>
);

Plus.propTypes = {
	className: string,
	style: objectOf(oneOfType([string, number])),
};
Plus.defaultProps = {
	className: "",
	style: {},
};

export default Plus;
export { Plus };
